import React from 'react';
import './LegalPage.css';

function CookiePolicyPage() {
  return (
    <div className="legal-page">
      <div className="legal-content">
        <h1 className="legal-page-title">COOKIE POLICY</h1>

        <div className="legal-section">
          <p>
            Access to this Website may involve the use of cookies. Cookies are small amounts of
            information stored in the browser used by each User — on the various devices they may use
            to browse — so that the server can remember certain information that will subsequently be
            read only by the server that implemented it. Cookies facilitate browsing, make it more
            user-friendly, and do not damage the browsing device.
          </p>
          <p>
            Cookies are automatic procedures for collecting information relating to the preferences
            determined by the User during their visit to the Website, in order to recognise them as a
            User and personalise their experience and use of the Website. They may also, for example,
            help to identify and resolve errors.
          </p>
          <p>
            The information collected through cookies may include the date and time of visits to the
            Website, the pages viewed, the time spent on the Website and the sites visited immediately
            before and after it. However, no cookie can contact the User's telephone number or any
            other personal means of contact. No cookie can extract information from the User's hard
            drive or steal personal information. The only way the User's private information can become
            part of the Cookie file is if the user personally provides that information to the server.
          </p>
          <p>
            Cookies that allow a person to be identified are considered personal data. Therefore, the
            Privacy Policy described above will apply to them. In this regard, the User's consent will
            be required for their use. This consent will be communicated, based on a genuine choice,
            offered through an affirmative and positive decision, prior to the initial processing,
            revocable and documented.
          </p>
        </div>

        <div className="legal-section">
          <h2>Social media cookies</h2>
          <p>
            Tabia Group incorporates social media plugins, which allow access to them from the Website.
            For this reason, social media cookies may be stored in the User's browser. The owners of
            these social networks have their own data protection and cookie policies, and they themselves
            are responsible, in each case, for their own files and their own privacy practices. The User
            should refer to these to find out about such cookies and, where applicable, the processing
            of their personal data. The following links are provided for information purposes only, where
            these privacy and/or cookie policies can be consulted:
          </p>
          <ul>
            <li>Facebook: <a href="https://www.facebook.com/policies/cookies/" target="_blank" rel="noopener noreferrer">https://www.facebook.com/policies/cookies/</a></li>
            <li>Twitter: <a href="https://twitter.com/es/privacy" target="_blank" rel="noopener noreferrer">https://twitter.com/es/privacy</a></li>
            <li>Instagram: <a href="https://help.instagram.com/1896641480634370?ref=ig" target="_blank" rel="noopener noreferrer">https://help.instagram.com/1896641480634370?ref=ig</a></li>
            <li>YouTube: <a href="https://policies.google.com/privacy?hl=es-419&gl=mx" target="_blank" rel="noopener noreferrer">https://policies.google.com/privacy?hl=es-419&gl=mx</a></li>
            <li>Pinterest: <a href="https://policy.pinterest.com/es/privacy-policy" target="_blank" rel="noopener noreferrer">https://policy.pinterest.com/es/privacy-policy</a></li>
            <li>LinkedIn: <a href="https://www.linkedin.com/legal/cookie-policy?trk=hp-cookies" target="_blank" rel="noopener noreferrer">https://www.linkedin.com/legal/cookie-policy?trk=hp-cookies</a></li>
          </ul>
        </div>

        <div className="legal-section">
          <h2>Disabling, rejecting and deleting cookies</h2>
          <p>
            The User can disable, reject and delete cookies — in whole or in part — installed on their
            device by configuring their browser (including, for example, Chrome, Firefox, Safari,
            Explorer). In this regard, the procedures for rejecting and deleting cookies may differ from
            one internet browser to another. The User should therefore refer to the instructions provided
            by the internet browser they are using. If the User rejects the use of cookies — in whole or
            in part — they may continue to use the Website, although the use of some of its features may
            be limited.
          </p>
        </div>

      </div>
    </div>
  );
}

export default CookiePolicyPage;
